export default __webpack_public_path__ + "static/media/bloco_image_4.57b871e5.svg";